'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dI$002dP$0024 from "./presto.types$-I-P$.js";
var $p;
/** @constructor */
function $c_Lpresto_Proxies$$anon$2() {
  this.bqw = null;
  this.bqu = null;
  this.bqv = false;
  this.bqs = null;
  this.bqt = false;
  this.bqx = false;
  this.bqy = false;
  this.bqw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Proxies$$anon$2 as $c_Lpresto_Proxies$$anon$2 };
$p = $c_Lpresto_Proxies$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Proxies$$anon$2;
/** @constructor */
function $h_Lpresto_Proxies$$anon$2() {
}
export { $h_Lpresto_Proxies$$anon$2 as $h_Lpresto_Proxies$$anon$2 };
$h_Lpresto_Proxies$$anon$2.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bqw;
});
$p.t = (function() {
  if ((!this.bqv)) {
    this.bqu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ip", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("city", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("region", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("country", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bqv = true;
  }
  return this.bqu;
});
$p.ae = (function() {
  if ((!this.bqt)) {
    this.bqs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dI$002dP$0024.$m_Lpresto_types$IP$().cs4(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bqt = true;
  }
  return this.bqs;
});
$p.w = (function() {
  if ((!this.bqy)) {
    this.bqx = false;
    this.bqy = true;
  }
  return this.bqx;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Proxies$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Proxies$$anon$2, "presto.Proxies$$anon$2", ({
  Pb: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Proxies$$anon$2 as $d_Lpresto_Proxies$$anon$2 };
//# sourceMappingURL=presto.-Proxies$$anon$2.js.map
